import overviewContent from './overview.json';
import type { ContentBlock, OverviewContent, OverviewKpiCardConfig } from './types';

export const overviewPageContent = overviewContent as OverviewContent;

export function getOverviewBlock(id: string): ContentBlock | undefined {
  return overviewPageContent.blocks.find((block) => block.id === id);
}

export function getOverviewBlockTitle(id: string, fallback = ''): string {
  return getOverviewBlock(id)?.title ?? fallback;
}

export function getOverviewBlockSubtitle(id: string, fallback = ''): string {
  return getOverviewBlock(id)?.subtitle ?? fallback;
}

export function getOverviewBlockTabLabel(id: string, fallback = ''): string {
  const block = getOverviewBlock(id);
  return block?.tabLabel ?? block?.title ?? fallback;
}

export function getOverviewBlockInfo(id: string, fallback = ''): string {
  return getOverviewBlock(id)?.info ?? fallback;
}

export function isKpiCardVisible(view: boolean | undefined): boolean {
  return view === true;
}

export function getVisibleKpiCards(): OverviewKpiCardConfig[] {
  return overviewPageContent.kpiCards.filter((card) => isKpiCardVisible(card.view));
}
